import { ApisauceInstance } from 'apisauce';

/**
 * Removes one ad-hoc recognition payment by id. Refused (400) only when the
 * period is closed / archived. Returns the same body as the GET.
 */
const deleteAdditionalPayment = ({
  api,
  driver,
  bonusProgramId,
  bonusDatasetRecordId,
  paymentId,
}: {
  api: ApisauceInstance;
  driver: string;
  bonusProgramId: string;
  bonusDatasetRecordId: string;
  paymentId: string;
}) => {
  return api.delete<
    BonusTypes.AdditionalPayments.Response,
    BonusTypes.AdditionalPayments.ErrorResponse
  >(
    `/v1/driver_bonus/additional_payments?driver=${driver}&driver_bonus_program_id=${bonusProgramId}&bonus_dataset_record_id=${bonusDatasetRecordId}&payment_id=${paymentId}`,
  );
};

export default deleteAdditionalPayment;
